import React from 'react';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import { ReactComponent as Gracias } from '../images/Gracias_reducido.svg';
import Typography from '@material-ui/core/Typography';
import Footer from './FooterAgradecimiento.js';

const useStyles = makeStyles((theme) => ({

  footer: {
    backgroundColor: '#ffffff',  
  }, 
  mensaje: {
    marginTop: theme.spacing(12),  
    marginLeft: theme.spacing(8),  
    marginRight: theme.spacing(8),  
    textAlign:"center"
  }, 
  logo: {
    width:"93%",  
    right:"7%",
  }, 
}));
function Agradecimiento() {
  const classes = useStyles();

  return (
    <div>
      <Container  component="main" maxWidth="xs" color='#fafafa'>
        <Grid>
          <Grid item xs={12}> 
            <Typography 
                className={classes.mensaje} 
                variant="h5">           
                ¡Muchas gracias!
                Juntos lo conseguimos         
            </Typography>             
            <Gracias className={classes.logo} />
          </Grid>
        </Grid>
      </Container>
      <Footer className={classes.footer}/>
    </div>
  
  );
}


export default Agradecimiento;